import { ActionIcon } from '@mantine/core';
import classNames from 'theme/components/Buttons/ActionIcon/ActionIcon.module.css';

export default ActionIcon.extend({
  classNames,
  defaultProps: {
    variant: 'primary',
    size: 'md',
  },
});
